/**
 * Opens a blank tab during the click, to be sent to an address that arrives later. Null if blocked.
 * Clears `opener` itself: with `noopener`, `window.open` returns no tab to send on.
 */
export const openPendingTab = (): Window | null => {
	const tab = window.open('', '_blank')
	if (tab !== null) {
		tab.opener = null
	}
	return tab
}
